function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0asfasdf)",
  filter: "url(#filter0_dafasfasd)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 300,
  height: 300,
  transform: "translate(50 42)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M145.943 109.29C151.747 81.0549 180.082 63.4954 207.95 70.8627L470.01 140.142C485.513 144.241 495.152 159.694 492.015 175.42L422.184 525.47C418.941 541.726 403.253 552.373 386.948 549.383L98.0097 496.4C81.2735 493.331 70.3302 477.105 73.7564 460.438L145.943 109.29Z",
  fill: "url(#paint0_linearfasfas)"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M183.518 142.33C188.011 126.558 204.231 117.219 220.126 121.253L453.319 180.428C466.025 183.652 473.137 197.174 468.594 209.47L372.892 468.521C368.689 479.898 356.095 485.752 344.688 481.631L130.3 404.171C119.392 400.231 113.395 388.52 116.572 377.367L183.518 142.33Z",
  fill: "url(#paint1_linearafafdsa)"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M203.573 195.469C206.915 184.887 217.676 178.508 228.563 180.655L435.389 221.436C442.113 222.762 446.015 229.831 443.554 236.227L359.667 454.267C357.598 459.646 351.738 462.527 346.214 460.88L149.989 402.385C144.081 400.624 140.761 394.364 142.618 388.486L203.573 195.469Z",
  fill: "url(#paint2_linearasfaasd)"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M216.606 251.947C220.304 241.26 231.294 234.916 242.398 237.058L397.919 267.067C405.516 268.533 409.286 277.158 405.201 283.729L327.177 409.262C325.225 412.403 321.829 414.357 318.132 414.467L174.727 418.727C167.007 418.956 161.445 411.387 163.97 404.088L216.606 251.947Z",
  fill: "url(#paint3_linearfasdasd)"
}), /*#__PURE__*/React.createElement("g", {
  opacity: 0.4
}, /*#__PURE__*/React.createElement("path", {
  d: "M228.752 293.129C232.151 285.204 240.473 280.573 249 281.864L389.908 303.198C397.179 304.298 401.359 312.069 398.272 318.743L337.339 450.452C335.241 454.986 330.36 457.545 325.438 456.692L183.923 432.162C176.9 430.944 172.856 423.489 175.665 416.939L228.752 293.129Z",
  fill: "url(#paint4_linearfadsadfa)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M228.752 293.129C232.151 285.204 240.473 280.573 249 281.864L389.908 303.198C397.179 304.298 401.359 312.069 398.272 318.743L337.339 450.452C335.241 454.986 330.36 457.545 325.438 456.692L183.923 432.162C176.9 430.944 172.856 423.489 175.665 416.939L228.752 293.129Z",
  fill: "url(#paint5_linearfasdasd)"
})), /*#__PURE__*/React.createElement("path", {
  opacity: 0.6,
  d: "M240.181 323.981C242.116 319.62 246.635 316.996 251.383 317.477L360.249 328.522C366.636 329.17 371.124 335.111 370.001 341.432L345.238 480.769C343.957 487.976 336.142 491.962 329.556 488.767L205.447 428.557C200.095 425.96 197.764 419.589 200.176 414.152L240.181 323.981Z",
  fill: "url(#paint6_linearfasdfasd)"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.7,
  d: "M249.476 356.827C251.49 352.75 255.799 350.326 260.329 350.721L350.421 358.577C358.172 359.252 362.809 367.52 359.344 374.486L321.688 450.191C319.066 455.462 312.77 457.747 307.378 455.385L230.335 421.629C224.57 419.104 222.081 412.276 224.869 406.633L249.476 356.827Z",
  fill: "url(#paint7_lineardasas)"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_dafasfasd",
  x: 0,
  y: 0,
  width: 400,
  height: 400,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 25
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.882465 0 0 0 0 0.918168 0 0 0 0 0.958333 0 0 0 0.6 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linearfasfas",
  x1: 261.568,
  y1: 408.062,
  x2: 419.237,
  y2: 107.833,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9D95EA",
  stopOpacity: 0.24
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.294933,
  stopColor: "#87B2E9",
  stopOpacity: 0.4
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.630744,
  stopColor: "#66CEE9",
  stopOpacity: 0.49
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4BCAF2",
  stopOpacity: 0.74
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linearafafdsa",
  x1: 254.225,
  y1: 172.436,
  x2: 407.85,
  y2: 260.701,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9D95EA",
  stopOpacity: 0.39
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.153833,
  stopColor: "#90A9EB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.294933,
  stopColor: "#87B2E9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.467727,
  stopColor: "#72C1E8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.630744,
  stopColor: "#66CEE9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.813475,
  stopColor: "#59D8E7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4BE3E4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linearasfaasd",
  x1: 264.993,
  y1: 214.207,
  x2: 387.886,
  y2: 284.831,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9D95EA",
  stopOpacity: 0.73
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.153833,
  stopColor: "#90A9EB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.294933,
  stopColor: "#87B2E9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.467727,
  stopColor: "#72C1E8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.630744,
  stopColor: "#66CEE9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.813475,
  stopColor: "#59D8E7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4BE3E4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linearfasdasd",
  x1: 259.17,
  y1: 261.377,
  x2: 342.543,
  y2: 309.332,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9D95EA",
  stopOpacity: 0.84
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.153833,
  stopColor: "#90A9EB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.294933,
  stopColor: "#87B2E9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.467727,
  stopColor: "#72C1E8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.630744,
  stopColor: "#66CEE9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.813475,
  stopColor: "#59D8E7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4BE3E4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linearfadsadfa",
  x1: 272.795,
  y1: 299.91,
  x2: 352.414,
  y2: 345.69,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9D95EA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.153833,
  stopColor: "#90A9EB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.294933,
  stopColor: "#87B2E9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.467727,
  stopColor: "#72C1E8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.630744,
  stopColor: "#66CEE9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.813475,
  stopColor: "#59D8E7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4BE3E4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linearfasdasd",
  x1: 272.795,
  y1: 299.91,
  x2: 352.414,
  y2: 345.69,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9D95EA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.153833,
  stopColor: "#90A9EB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.294933,
  stopColor: "#87B2E9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.467727,
  stopColor: "#72C1E8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.630744,
  stopColor: "#66CEE9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.813475,
  stopColor: "#59D8E7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4BE3E4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linearfasdfasd",
  x1: 261.917,
  y1: 353.196,
  x2: 357.672,
  y2: 408.26,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9D95EA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.153833,
  stopColor: "#90A9EB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.294933,
  stopColor: "#87B2E9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.467727,
  stopColor: "#72C1E8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.630744,
  stopColor: "#66CEE9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.813475,
  stopColor: "#59D8E7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4BE3E4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_lineardasas",
  x1: 235.917,
  y1: 379.336,
  x2: 347.497,
  y2: 394.376,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A768C5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.634549,
  stopColor: "#E492AB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F3B2B8"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0asfasdf"
}, /*#__PURE__*/React.createElement("rect", {
  width: 300,
  height: 300,
  fill: "white",
  transform: "translate(50 42)"
})));

function SvgIntro2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntro2);
export default __webpack_public_path__ + "static/media/intro2.dc2c57f6.svg";
export { ForwardRef as ReactComponent };